import { render, staticRenderFns } from "./billRecord_gr.vue?vue&type=template&id=5c589312&scoped=true&"
import script from "./billRecord_gr.vue?vue&type=script&lang=js&"
export * from "./billRecord_gr.vue?vue&type=script&lang=js&"
import style0 from "./billRecord_gr.vue?vue&type=style&index=0&id=5c589312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c589312",
  null
  
)

export default component.exports